import { styled } from '../../../core/theme/styled';

/**
 * ContentOverlay is responsible for rendering a full screen overlay,
 * no matter where it is rendered in the DOM. It guarantees that the overlay
 * will fill the whole application size
 */

export const StyledContainer = styled.div`
  align-items: center;
  background: ${(props) => props.theme.configuration.backgroundColor};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`;
